/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetUploadByPlatformAndKeyQueryResponse, SocialExportGetUploadByPlatformAndKeyPathParams, SocialExportGetUploadByPlatformAndKey400, SocialExportGetUploadByPlatformAndKey401, SocialExportGetUploadByPlatformAndKey403 } from "../models/SocialExportGetUploadByPlatformAndKey";

export function getSocialExportGetUploadByPlatformAndKeyUrl(key: SocialExportGetUploadByPlatformAndKeyPathParams["key"], platform: SocialExportGetUploadByPlatformAndKeyPathParams["platform"]) {
  const res = { method: 'GET', url: `/social-export/v1/upload/by-key/${platform}/${key}` as const }
  return res
}

/**
 * @description Returns a single upload for the given platform and key belonging to the authenticated client, or null if none exists.
 * @summary Get an upload by platform and key
 * {@link /social-export/v1/upload/by-key/:platform/:key}
 */
export async function socialExportGetUploadByPlatformAndKey(key: SocialExportGetUploadByPlatformAndKeyPathParams["key"], platform: SocialExportGetUploadByPlatformAndKeyPathParams["platform"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SocialExportGetUploadByPlatformAndKeyQueryResponse, ResponseErrorConfig<SocialExportGetUploadByPlatformAndKey400 | SocialExportGetUploadByPlatformAndKey401 | SocialExportGetUploadByPlatformAndKey403>, unknown>({ method : "GET", url : getSocialExportGetUploadByPlatformAndKeyUrl(key, platform).url.toString(), ... requestConfig })
  return res.data
}